module.exports = __webpack_public_path__ + "img/share-2.d60c744b.svg";